import Moment from 'moment';

export const convertToReadable = (dateString) => {
    if (!!dateString === false) {return null}
    return Moment(dateString).format("MM/DD/YYYY")
}

export const convertYYYMMDDtoDate = (dateString) => {
    if (!!dateString === false) {return null}
    const year = +dateString.substring(0, 4);
    const month = +dateString.substring(5, 7);
    const day = +dateString.substring(8, 10);
    const date = new Date(year, month - 1, day);
    return date
}
export const convertDateToYYMMDD = (dateString) => {
    if(!!dateString === false) {return null}
    return Moment(dateString).format('YYYY-MM-DD')
}
